<template>
  <div>
    <div class="page-header page-header-small clear-filter">
      <parallax
        class="page-header-image"
        style="background-image:url('img/bg4.jpg')"
      >
      </parallax>
        <div class="content-center brand">
          <h1 class="h1-seo">Manager</h1>
        </div>
    </div>
    
    <section id="documents" class="section">
      <div class="container">
        <div class="row justify-content-md-center">
          <div class="col-md-12 col-lg-8">
            <h2 class="title">Documents</h2>
             <ul>
                <li v-for="doc in docs" :key="doc.title"><a :href="/docs/ + doc.document" target="_blank">{{doc.title}}</a></li>
            </ul>
            <div  class="col-md-6" v-for="report in reports" :key="report.year">
              <h3 class="subtitle pt-1 mb-2">{{report.year}}</h3>
             <ul>
                <li v-for="doc in report.docs" :key="doc.title"><a :href="/docs/ + doc.document" target="_blank">{{doc.title}}</a></li>
            </ul>
            </div>
            <p class="pl-3 pt-4">All mandatory information can be provided on request with a copy and, if applicable, the costs involved.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
</template>
<script>
import { Parallax } from '@/components';

export default {
  name: 'index',
  bodyClass: 'index-page',
  data() {
    return {
      reports: [
          {
          year: 2025,
          docs: [
            {
              title: 'Halfjaarverslag beheerder',
              document: '20250721 - Halfjaarrekening 2025 ABCFM.pdf'
            }
          ]
        },
        {
          year: 2024,
          docs: [
              {
              title: 'Jaarverslag ABCFM',
              document: '20250627 - Alpha Based Capital Fund Management B.V. Jaarrekening  2024 - SIGNED.pdf'
            },
            {
              title: 'Halfjaarverslag beheerder',
              document: 'Alpha Based Capital Fund Management B.V. - Halfjaar cijfers  2024.pdf'
            }
          ]
        },
        {
          year: 2023,
          docs: [
            {
              title: 'Jaarverslag beheerder',
              document: 'Alpha Based Capital Fund Management BV (beheerder) - Jaarrekening 2023.pdf'
            },
            {
              title: 'Halfjaarverslag beheerder',
              document: 'Halfjaarverslag 2023 Alpha Based Capital Fund Management.pdf'
            }
          ]
        },
        {
          year: 2022,
          docs: [
            {
              title: 'Jaarverslag beheerder',
              document: '20230630 - Alpha Based Capital Fund Management BV - Jaarrekening 2022 (MANAGER).pdf'
            },
            {
              title: 'Halfjaarverslag beheerder',
              document: 'halfjaarrekening ABC FM BV 2021.pdf'
            }
          ]
        },
        {
          year: 2021,
          docs: [
            {
              title: 'Jaarverslag beheerder',
              document: '21 - Alpha Based Capital Fund Management BV - jaarrekening.pdf'
            },
            {
              title: 'Halfjaarverslag beheerder',
              document: 'halfjaarrekening ABC FM BV 2021.pdf'
            }
          ]
        },
        {
          year: 2020,
          docs: [
            {
              title: 'Jaarverslag beheerder',
              document: '20 - Alpha Based Capital Fund Management B.V. - Jaarrekening controleverklaring - getekend.pdf'
            },
            {
              title: 'Halfjaarverslag beheerder',
              document: 'Financieel halfjaar verslag 2020.pdf'
            }
          ]
        },
        {
          year: 2019,
          docs: [
             {
              title: 'Jaarverslag beheerder',
              document: '19 - Alpha Based Capital Fund Management BV - jaarrekening.pdf'
            },
            {
              title: 'Halfjaarverslag beheerder',
              document: 'Financieel-halfjaar-verslag-2019.pdf'
            }
          ]
        },
        {
          year: 2018,
          docs: [
            {
              title: 'Halfjaarverslag beheerder',
              document: 'ABCFM-FS-halfjaarverslag-2018.pdf'
            },
            {
              title: 'Jaarverslag beheerder',
              document: '18-Alpha-Based-Capital-Fund-Management-B.V.-w.g.-jaarrekening.pdf'
            }
          ]
        },
        {
          year: 2017,
          docs: [
            {
              title: 'Halfjaarverslag beheerder',
              document: 'halfjaarverslag-beheerder2017.pdf'
            },
            {
              title: 'Jaarverslag beheerder',
              document: '2018.048364-Gewaarmerkte-jaarstukken-2017-Alpha-Based-Capital-Fund-Management-B.V..pdf'
            }
          ],
        },
        {
          year: 2016,
          docs: [
            {
              title: 'Halfjaarverslag beheerder',
              document: '2016-Halfjaarverslag-Beheerder.pdf'
            },
            {
              title: 'Jaarverslag beheerder',
              document: 'ABCFM-FS-jaarverslag-2016-V2.1-gestempeld-en-geparafeerd-incl.-getekende-verklaring.pdf'
            }
          ],
        }
      ],

      docs: [
        {
          title: 'Directiebesluit ABCFM',
          document: 'BIJLAGE 11 20230927 Directiebesluit ABCFM.pdf'
        },
        {
          title: 'Bericht aan Participanten inzake Alpha Based Capital Fonds',
          document: '20231012 Bericht aan participanten in Alpha Based Capital  Fonds.pdf'
        },
        {
          title: 'KvK Alpha Based Capital Fund Management BV',
          document: '20241110 - KvK uittreksel Alpa Based Capital Fund Management BV.pdf'
        },
        {
          title: 'KvK Apex Depositary Services BV',
          document: '20230629 - KvK Uittreksel Apex Depositary Services BV (Darwin).pdf'
        },
        {
          title: 'Beloningsbeleid',
          document: '20201016 - Beloningsbeleid.pdf'
        },
        {
          title: 'Vergunning',
          document: 'Vergunning.pdf'
        },
        {
          title: 'Statutenwijziging',
          document: 'Statutenwijziging.pdf'
        },
        {
          title: 'Mededeling Beheerder januari 2017',
          document: 'Mededeling-van-de-Beheerder-januari-2017-.pdf'
        },
        {
          title: 'Mededeling Beheerder februari 2017',
          document: 'Utrecht-1-februari-2017.docx'
        },
      ]
    }
  },
  components: {
    Parallax
  }
};
</script>
<style></style>
